import { useEffect, useState } from "react"
import { getTeamGear, updateTeamGear } from "../../../../API/teamGear"
import useNotification from "../../../../hooks/useNotification";
import MUIDataTable from "mui-datatables";
import { Button, CircularProgress, LinearProgress } from "@mui/material";
import LazyImage from "../../../common/LazyImage";
import EditObject from "../../../common/EditObject";

export const ListTeamGear = ({ school, user, refresh, setRefresh }) => {

    const [teamGears, setTeamGears] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false)
    const [athleteEditModal, setAthleteEditModal] = useState(false);
    const [selectedTeamGear, setSelectedTeamGear] = useState(null);
    const [loadingUpdate, setLoadingUpdate] = useState(false)

    const notify = useNotification()

    useEffect(() => {
        const fetchData = async () => {
            if (school || refresh) {
                try {
                    setLoading(true)
                    const response = await getTeamGear(school, user)
                    setTeamGears(response?.data?.obj || [])
                } catch (error) {
                    console.error('error fetching team gear: ', error)
                    notify("failed to load existing team gears")
                } finally {
                    setLoading(false)
                    setRefresh(false)
                }

            }
        }

        fetchData()
    }, [user, refresh])

    const columns = [
        {
            label: "Team Id", name: "team_id", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Sport", name: "sport", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Coach Name", name: "coach_name", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Email", name: "email", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Phone", name: "phone", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Paypal Email", name: "paypal_email", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Venmo Phone", name: "venmo_phone", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>{value}</div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "Collection Photo", name: "photo", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div style={{
                        whiteSpace: "nowrap",
                    }}>
                        {value && <LazyImage
                            alt={"collection image"}
                            style={{ maxHeight: "25px" }}
                            src={value}
                            onClick={() => {
                                window.open(value, "_blank");
                            }}
                        />}
                    </div>
                ),
                filter: false,
                sortThirdClickReset: true
            }
        },
        {
            label: "edit",
            name: "edit",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Button
                        onClick={() => {
                            const rowData = teamGears[tableMeta.rowIndex]; // Get that row’s data
                            setSelectedTeamGear(rowData);
                            setAthleteEditModal(true)
                        }}
                    >
                        Edit
                    </Button>
                )
            }
        }
    ]

    const options = {
        filter: true,
        // sortOrder: { name: "sport", direction: 'asc' },
        selectableRows: "none",
        selectableRowsHeader: false,
        rowsPerPageOptions: [5, 10, 25, 100, 200],
        rowsPerPage: rowsPerPage,
        onChangeRowsPerPage: (num) => setRowsPerPage(num),
        textLabels: {
            body: {
                noMatch: loading ? (
                    <CircularProgress />
                ) : (
                    "No Records"
                ),
            },
        },
        download: true,
    };

    const editConfig = [
        {
            label: "Team ID",
            type: "text",
            field: "team_id",
            style: { xs: 12, lg: 6 },
            can: false,
        },
        {
            label: "Sport",
            type: "text",
            field: "sport",
            style: { xs: 12, lg: 6 },
            can: false,
        },
        {
            label: "Coach Name",
            type: "text",
            field: "coach_name",
            style: { xs: 12, lg: 6 },
            can: true,
        },
        {
            label: "Email",
            type: "text",
            field: "email",
            style: { xs: 12, lg: 6 },
            can: true,
            isValid: (value) => {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailPattern.test(value) && value.length !== 0) {
                    return "Please enter a valid email address";
                }
            },
        },
        {
            label: "Phone",
            type: "text",
            field: "phone",
            style: { xs: 12, lg: 12 },
            can: true,
            isValid: (value) => {
                const phoneNumberPattern = /^\d{10}$/;
                if (!phoneNumberPattern.test(value) && value.length !== 0) {
                    return "The phone number must be in the following format: 8053909939";
                }
            },
        },
        {
            label: "Paypal Email",
            type: "text",
            field: "paypal_email",
            style: { xs: 12, lg: 12 },
            can: true,
            isValid: (value) => {
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailPattern.test(value) && value.length !== 0) {
                    return "Please enter a valid email address";
                }
            },
        },
        {
            label: "Venmo Phone",
            type: "text",
            field: "venmo_phone",
            style: { xs: 12, lg: 12 },
            can: true,
            isValid: (value) => {
                const phoneNumberPattern = /^\d{10}$/;
                if (!phoneNumberPattern.test(value) && value.length !== 0) {
                    return "The phone number must be in the following format: 18053909939";
                }
            },
        },
    ];

    const saveChanges = async (altered) => {
        if (Object.keys(altered).length === 0) return;

        try {
            setLoadingUpdate(true);
            const response = await updateTeamGear({
                team: {
                    ...altered,
                    team_id: selectedTeamGear?.team_id || -1
                }
            }, user)
        } catch (error) {
            console.error("error updating team gear: ", error)
            notify("failed to update team gear")
        } finally {
            setLoadingUpdate(false);
            setRefresh(true)
        }
    }

    return (
        <div>
            <EditObject
                title={"Edit Team"}
                save={(altered) => {
                    saveChanges(altered);
                    setAthleteEditModal(false);
                }}
                cancel={() => {
                    setAthleteEditModal(false);
                }}
                open={athleteEditModal}
                config={editConfig}
                object={selectedTeamGear || {}}
                style={{
                    backgroundColor: "background.default",
                    margin: "auto",
                    marginTop: "10vh",
                    padding: "20px",
                    width: "60vw",
                    borderRadius: "5px",
                }}
            />
            {(loadingUpdate || refresh) && <LinearProgress />}
            <MUIDataTable
                title="Exsiting Team Gear"
                data={teamGears}
                columns={columns}
                options={options}
            />
        </div>
    )
}